"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringValuedAsyncStore = void 0;
/**
 * Asynchronous store that operates using a provided underlying engine that stores strings.
 * Example string-based storage engines include a browser's local storage, or a Chrome extension's
 * chrome storage.
 * Objects are stored by serializing to JSON strings, and then retrieved by deserializing.
 */
class StringValuedAsyncStore {
    constructor(storageEngine, cooldownSeconds = 0) {
        this.storageEngine = storageEngine;
        this.cooldownSeconds = cooldownSeconds;
        this.initialized = false;
    }
    isInitialized() {
        return this.initialized;
    }
    async isExpired() {
        if (!this.cooldownSeconds) {
            return true;
        }
        const metaJsonString = await this.storageEngine.getMetaJsonString();
        let isExpired = true;
        if (metaJsonString) {
            const parsedMeta = JSON.parse(metaJsonString);
            const lastUpdatedAt = parsedMeta.lastUpdatedAtMs;
            isExpired = !lastUpdatedAt || Date.now() - lastUpdatedAt > this.cooldownSeconds * 1000;
        }
        return isExpired;
    }
    async entries() {
        const contentsJsonString = await this.storageEngine.getContentsJsonString();
        return contentsJsonString ? JSON.parse(contentsJsonString) : {};
    }
    async setEntries(entries) {
        // String-based storage takes a dictionary of key-value string pairs,
        // so we write the entire configuration and meta to a single location for each.
        await this.storageEngine.setContentsJsonString(JSON.stringify(entries));
        const updatedMeta = { lastUpdatedAtMs: new Date().getTime() };
        await this.storageEngine.setMetaJsonString(JSON.stringify(updatedMeta));
        this.initialized = true;
    }
}
exports.StringValuedAsyncStore = StringValuedAsyncStore;
//# sourceMappingURL=string-valued.store.js.map